<template>
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1666 4.99996H16.6666C17.5916 4.99996 18.3333 5.74163 18.3333 6.66663V15.8333C18.3333 16.7583 17.5916 17.5 16.6666 17.5H3.33329C2.40829 17.5 1.66663 16.7583 1.66663 15.8333V6.66663C1.66663 5.74163 2.40829 4.99996 3.33329 4.99996H5.83329V3.33329C5.83329 2.40829 6.57496 1.66663 7.49996 1.66663H12.5C13.425 1.66663 14.1666 2.40829 14.1666 3.33329V4.99996ZM12.5 3.33329H7.49996V4.99996H12.5V3.33329ZM16.6666 15.8333H3.33329V14.1666H16.6666V15.8333ZM3.33329 11.6666H16.6666V6.66663H14.1666V8.33329H12.5V6.66663H7.49996V8.33329H5.83329V6.66663H3.33329V11.6666Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>


<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>